import { authHeaders, type PanelAuth } from '../lib/panel-auth';

/**
 * Пояс устройства для отправки в /telegram/auth (захват per-user времени).
 *
 * Telegram Mini App крутится в WebView (настоящий браузерный движок) → Intl всегда доступен и
 * отдаёт IANA-зону устройства (напр. "Asia/Yekaterinburg"). Defensive: если по какой-то причине
 * Intl недоступен — возвращаем undefined, сервер fail-open (пояс не пишется, авторизация цела).
 */
export function clientTimezone(): string | undefined {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || undefined;
  } catch {
    return undefined;
  }
}

/**
 * Репорт пояса устройства на КАЖДОМ открытии мини-апа (fire-and-forget, с готовым JWT).
 *
 * Захват на /telegram/auth ловит только свежий логин; студии переиспользуют JWT из localStorage
 * и на большинстве открытий /telegram/auth НЕ дёргают. Этот репорт закрывает класс: любой мини-ап
 * зовёт на mount → пояс пишется всегда. Тихий (не блокирует UI, глушит любые ошибки сети/РКН).
 */
export function reportTimezone(apiBase: string, token: PanelAuth | null | undefined): void {
  const tz = clientTimezone();
  if (!token || !tz) return;
  try {
    void fetch(`${apiBase}/v1/timezone`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeaders(token) },
      body: JSON.stringify({ clientTimezone: tz }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* сеть/РКН — пояс не критичен, не мешаем открытию */
  }
}
